package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class SimulationLineQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    simulation_id: String,
    label: String,
    expression: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_079_258_416, arrayOf("simulation_line"), driver, "SimulationLine.sq",
      "selectAll",
      "SELECT simulation_line.id, simulation_line.simulation_id, simulation_line.label, simulation_line.expression, simulation_line.order_index, simulation_line.created_at, simulation_line.updated_at, simulation_line.is_deleted, simulation_line.deleted_at, simulation_line.synced_at FROM simulation_line WHERE is_deleted = 0 ORDER BY simulation_id, order_index, created_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectAll(): Query<Simulation_line> = selectAll { id, simulation_id, label, expression,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Simulation_line(
      id,
      simulation_id,
      label,
      expression,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBySimulation(simulation_id: String, mapper: (
    id: String,
    simulation_id: String,
    label: String,
    expression: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectBySimulationQuery(simulation_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectBySimulation(simulation_id: String): Query<Simulation_line> =
      selectBySimulation(simulation_id) { id, simulation_id_, label, expression, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Simulation_line(
      id,
      simulation_id_,
      label,
      expression,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    simulation_id: String,
    label: String,
    expression: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(2_082_910_113, arrayOf("simulation_line"), driver, "SimulationLine.sq",
      "selectDirty",
      "SELECT simulation_line.id, simulation_line.simulation_id, simulation_line.label, simulation_line.expression, simulation_line.order_index, simulation_line.created_at, simulation_line.updated_at, simulation_line.is_deleted, simulation_line.deleted_at, simulation_line.synced_at FROM simulation_line WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectDirty(): Query<Simulation_line> = selectDirty { id, simulation_id, label,
      expression, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Simulation_line(
      id,
      simulation_id,
      label,
      expression,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    simulation_id: String,
    label: String,
    expression: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Simulation_line> = selectByIdAnyState(id) { id_,
      simulation_id, label, expression, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Simulation_line(
      id_,
      simulation_id,
      label,
      expression,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    simulation_id: String,
    label: String,
    expression: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_062_901_870, """
        |INSERT INTO simulation_line(id, simulation_id, label, expression, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, id)
          bindString(1, simulation_id)
          bindString(2, label)
          bindString(3, expression)
          bindLong(4, order_index)
          bindLong(5, created_at)
          bindLong(6, updated_at)
        }
    notifyQueries(1_062_901_870) { emit ->
      emit("simulation_line")
    }
  }

  public fun update(
    label: String,
    expression: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_407_848_062,
        """UPDATE simulation_line SET label = ?, expression = ?, updated_at = ? WHERE id = ?""", 4)
        {
          bindString(0, label)
          bindString(1, expression)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(1_407_848_062) { emit ->
      emit("simulation_line")
    }
  }

  public fun setOrder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(105_415_809,
        """UPDATE simulation_line SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(105_415_809) { emit ->
      emit("simulation_line")
    }
  }

  public fun updateFromRemote(
    simulation_id: String,
    label: String,
    expression: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_230_472_786,
        """UPDATE simulation_line SET simulation_id = ?, label = ?, expression = ?, order_index = ?, updated_at = ? WHERE id = ?""",
        6) {
          bindString(0, simulation_id)
          bindString(1, label)
          bindString(2, expression)
          bindLong(3, order_index)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(-1_230_472_786) { emit ->
      emit("simulation_line")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(158_208_426,
        """UPDATE simulation_line SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(158_208_426) { emit ->
      emit("simulation_line")
    }
  }

  public fun softDeleteForSimulation(
    deleted_at: Long?,
    updated_at: Long,
    simulation_id: String,
  ) {
    driver.execute(-159_217_114,
        """UPDATE simulation_line SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE simulation_id = ? AND is_deleted = 0""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, simulation_id)
        }
    notifyQueries(-159_217_114) { emit ->
      emit("simulation_line")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(2_025_567_097,
        """UPDATE simulation_line SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(2_025_567_097) { emit ->
      emit("simulation_line")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_361_102_044,
        """UPDATE simulation_line SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_361_102_044) { emit ->
      emit("simulation_line")
    }
  }

  private inner class SelectBySimulationQuery<out T : Any>(
    public val simulation_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("simulation_line", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("simulation_line", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_190_767_375,
        """SELECT simulation_line.id, simulation_line.simulation_id, simulation_line.label, simulation_line.expression, simulation_line.order_index, simulation_line.created_at, simulation_line.updated_at, simulation_line.is_deleted, simulation_line.deleted_at, simulation_line.synced_at FROM simulation_line WHERE simulation_id = ? AND is_deleted = 0 ORDER BY order_index, created_at""",
        mapper, 1) {
      bindString(0, simulation_id)
    }

    override fun toString(): String = "SimulationLine.sq:selectBySimulation"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("simulation_line", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("simulation_line", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_624_286_904,
        """SELECT simulation_line.id, simulation_line.simulation_id, simulation_line.label, simulation_line.expression, simulation_line.order_index, simulation_line.created_at, simulation_line.updated_at, simulation_line.is_deleted, simulation_line.deleted_at, simulation_line.synced_at FROM simulation_line WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "SimulationLine.sq:selectByIdAnyState"
  }
}
